"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "m 6.1034486,1.0755211 h 3.8214047 a 1.09183,1.09183 0 0 1 1.0918297,1.09183 V 9.8101616 A 1.09183,1.09183 0 0 1 9.9248533,10.901992 H 6.1034486 m 0,-9.8264709 h -3.821405 a 1.09183,1.09183 0 0 0 -1.0918301,1.09183 v 7.6428105 a 1.09183,1.09183 0 0 0 1.0918301,1.0918304 h 3.821405 m 0,-9.8264709 v 9.8264709",
    id: "path5677",
    strokeWidth: "2",
    strokeMiterlimit: "4",
    strokeDasharray: "none"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "m 22.918754,17.991096 v 3.812598 a 1.0893138,1.0893138 0 0 1 -1.089314,1.089314 h -7.625196 a 1.0893138,1.0893138 0 0 1 -1.089315,-1.089314 v -3.812598 m 9.803825,0 V 14.178497 A 1.0893138,1.0893138 0 0 0 21.82944,13.089183 h -7.625196 a 1.0893138,1.0893138 0 0 0 -1.089315,1.089314 v 3.812599 m 9.803825,0 h -9.803825",
    id: "path5677-6",
    strokeWidth: "2",
    strokeMiterlimit: "4",
    strokeDasharray: "none"
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    id: "g5734",
    transform: "matrix(0,0.40920432,-0.40920432,0,24.111818,8.7132862)",
    strokeWidth: "4.88753414",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
      id: "polyline5702",
      points: "15 14 20 9 15 4",
      transform: "translate(-17.25644,2.9014196)",
      strokeWidth: "4.88753414",
      strokeMiterlimit: "4",
      strokeDasharray: "none"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      id: "path5704",
      d: "m -13.25644,22.90142 v -7 a 4,4 0 0 1 3.9999998,-4 h 12",
      strokeWidth: "4.88753414",
      strokeMiterlimit: "4",
      strokeDasharray: "none"
    })]
  })]
}));